import { createContext } from 'react';
import { AdminAuthResponse, AdminRole } from '../../services/admin/admin.service';

export function getLoginPathForRole(role: AdminRole): string {
  switch (role) {
    case 'SALES':
      return '/auth/sales/login';
    case 'ADMIN':
    case 'SUPER_ADMIN':
    default:
      return '/auth/admin/login';
  }
}

export function getDefaultRouteForRole(role: AdminRole): string {
  switch (role) {
    case 'SALES':
      return '/sales/leads';
    case 'ADMIN':
    case 'SUPER_ADMIN':
    default:
      return '/admin/dashboard';
  }
}

interface AdminAuthContextType {
  user: AdminAuthResponse | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (data: AdminAuthResponse) => void;
  logout: () => void;
}

export const AdminAuthContext = createContext<AdminAuthContextType>({
  user: null,
  isAuthenticated: false,
  isLoading: true,
  login: () => {},
  logout: () => {},
});